import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#080808] border-t border-[#1c1c1c]" data-testid="footer">
      {/* Gold line top */}
      <div className="gold-line" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <span className="font-heading text-3xl font-bold text-gold tracking-wider">NELI</span>
              <p className="text-[10px] tracking-[0.3em] text-[#a3a3a3] uppercase mt-1">Restaurante · Ansoáin</p>
            </div>
            <p className="font-body text-[#a3a3a3] text-sm leading-relaxed max-w-xs mt-4">
              Cocina familiar con sabor auténtico en el corazón de Ansoáin, Navarra. Tradición, calidad y un trato amable en cada visita.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-[#ededed] text-sm tracking-widest uppercase mb-6">Navegación</h4>
            <ul className="space-y-3">
              {[
                { label: 'Inicio', id: 'hero' },
                { label: 'Nosotros', id: 'about' },
                { label: 'Servicios', id: 'services' },
                { label: 'Preguntas frecuentes', id: 'faq' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="font-body text-[#a3a3a3] hover:text-gold text-sm transition-colors duration-300"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-[#ededed] text-sm tracking-widest uppercase mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-gold mt-0.5 flex-shrink-0" />
                <span className="font-body text-[#a3a3a3] text-sm">Ctra. Ansoáin, 6<br />31013 Ansoáin, Navarra</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={14} className="text-gold flex-shrink-0" />
                <a href="tel:948595567" className="font-body text-[#a3a3a3] hover:text-gold text-sm transition-colors">
                  948 59 55 67
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock size={14} className="text-gold flex-shrink-0" />
                <span className="font-body text-[#a3a3a3] text-sm">Todos los días hasta las 22:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#1c1c1c] max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-body text-[#a3a3a3] text-xs">
          © {new Date().getFullYear()} Restaurante Neli · Todos los derechos reservados
        </p>
        <Link
          to="/admin"
          className="font-body text-[#2a2a2a] hover:text-[#a3a3a3] text-xs transition-colors duration-300"
          data-testid="admin-link"
        >
          Admin
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
